import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { primitive } from 'styles/constants';

export const CurrencyLineSkeleton = () => (
  <Box style={styles.container}>
    <Skeleton
      testID="currency-line-skeleton"
      height="15px"
      width="full"
      color={primitive.$greyFour}
    />
  </Box>
);

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
});
